
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import icoLY from '@/assets/ico-ly.png'
import icoDel from '@/assets/ico-del.png'
import { dealLetter,dealAppoint } from '@/api/youzheng.js'
import Storage from '@/storage'
import store from '@/store'
export default {
name: 'myReply',
data () {
return {
id:this.$route.params.id,
content:'',
accounttype: this.$store.state.user.personObj.accounttype,
isqyb: this.$store.state.user.personObj.isqyb
}
},
components: {
XTextarea,
Group,
Flexbox,
FlexboxItem,
XButton
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
methods: {

getsumbit(){
if(this.content!=''){
dealAppoint({
accountid:this.accountid,
id:this.id,
content:this.content,
}).then(res=>{
this.$vux.toast.text('提交成功', 'middle')
this.$router.push({name:'myMailWorkQyDaiban',params:{selected:2,tabIndex:0}})
})
}else{
this.$vux.toast.text('请填写回复内容', 'middle')
}
},

clean(){
this.content= ''
this.upimagelist = []
}
},
activated () {},
created () {
}
}
